import React from 'react';
import { DropdownMenu, MenuItem } from '@react-md/menu';
import { BELOW_INNER_RIGHT_ANCHOR } from '@react-md/utils';
import './HeaderDropDown.scss';
import cn from 'classnames';

const HeaderDropDown = ({ className, children, dropDownContent }) => {
  return (
    <DropdownMenu
      id={className || 'ph-header-dropdown'}
      className={cn('ph-header-menu-btn', className)}
      buttonChildren={children}
      buttonType="icon"
      anchor={BELOW_INNER_RIGHT_ANCHOR}
    >
      <MenuItem className="ph-header-menu-item">
        {dropDownContent}
      </MenuItem>
    </DropdownMenu>
  );
};

export default HeaderDropDown;
